import { http, onSuccess, onFail } from '../player/http';

export const getEventNotifications = (eventKey) => {
    return http.get(`/api/cp/event/${eventKey}/notification`)
        .then(onSuccess, onFail);
};

export const createEventNotification = (eventKey, data) => {
    return http.post(`/api/cp/event/${eventKey}/notification`, data)
        .then(onSuccess, onFail);
};

export const updateEventNotification = (notificationID, data) => {
    return http.put(`/api/cp/event/notification/${notificationID}`, data)
        .then(onSuccess, onFail);
};

export const deleteEventNotification = (notificationID) => {
    return http.delete(`/api/cp/event/notification/${notificationID}`)
        .then(onSuccess, onFail);
};

export const updateEventNotificationPoster = (notificationID, data) => {
    return http.post(`/api/cp/event/notification/${notificationID}/poster`, data)
        .then(onSuccess, onFail);
};

export const sendEventNotification = (notificationID) => {
    return http.post(`/api/cp/event/notification/${notificationID}/send`)
        .then(onSuccess, onFail);
};